exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NavFooter {\n  margin-top: 1.5rem;\n  text-transform: uppercase;\n}\n.NavFooter ul {\n  column-rule: none;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.NavFooter ul li {\n  padding: 0.5rem 1.5rem;\n}\n.NavFooter .copyright {\n  font-size: 0.75rem;\n  text-transform: none;\n}\n", ""]);

